export default {
  // Page titles and headers
  pageTitle: 'Areas I am satisfied with',
  subtitle: 'Choose the {count} areas you are most satisfied with',
  goalsTitle: 'My Goals',
  goalsSubtitle: 'Set your personal goals',
  improveTitle: 'Areas to improve',
  improveSubtitle: 'Choose areas you want to work on',
  satisfiedWith: 'This I am satisfied with',
  wantToImprove: 'This I want to improve',
  
  // Button labels
  saveGoals: 'Save Goals',
  continueToPlan: 'Continue to Plan',
  backToGoals: 'Back to Goals',
  selectGoals: 'Select Goals',
  clearSelection: 'Clear Selection',
  
  // Loading states
  loadingValues: 'Loading values...',
  loadingGoals: 'Loading goals...',
  savingChoices: 'Saving your choices...',
  loadingOptions: 'Loading your options...',
  savingGoals: 'Saving goals...',
  
  // Selection messages
  maxSelections: 'Maximum {count} selections',
  selectedCount: '{count} selected',
  selectMore: 'Please select {count} more',
  tooManySelected: 'Too many selected. Please deselect some.',
  selectedAreas: 'Selected areas: {count}/{max}',
  
  // Instructions
  instructions: 'Instructions',
  selectInstructions: 'Click on the areas you want to select',
  deselectInstructions: 'Click again to deselect',
  maxSelectionReached: 'Maximum selection reached',
  improveInstructions: 'Here is the list of what you said you want to improve.',
  improveInstructionsDetail: 'Choose the areas (max 3) that are most important for you to improve. For each one, you then click on the value you want to achieve. For example, going from value 1 (risk value) to 5 for physical activity. These are your GOALS. Change until it feels good. Click on the starting value to undo.',
  
  // Plan page translations
  howToReachGoals: 'HOW will you reach your GOALS?',
  yourImportantGoals: 'Here are your most important GOALS. Click on each one and describe as briefly as you can, WHAT you plan to do to achieve the goal.',
  goToEvaluation: 'Go to evaluation',
  fillAllGoals: 'Fill in all your goals to continue',
  valueIncrease: 'I have chosen to increase my value from {from} to {to}.',
  writeYourPlan: 'Now, finally, just write in your own words what you will do to achieve your goal:',
  writeBriefly: 'Write very briefly WHAT you will do to reach your goal.',
  goalAchievedBy: 'I want my GOAL to be achieved by:',
  date: 'Date',
  dateRequired: 'You must fill in a date.',
  save: 'Save',
  
  // Categories
  physical: 'Physical',
  mental: 'Mental',
  social: 'Social',
  work: 'Work',
  lifestyle: 'Lifestyle',
  health: 'Health',
  fitness: 'Fitness',
  nutrition: 'Nutrition',
  sleep: 'Sleep',
  stress: 'Stress',
  relationships: 'Relationships',
  workLifeBalance: 'Work-Life Balance',
  
  // Status messages
  goalsSaved: 'Goals saved successfully',
  goalsUpdated: 'Goals updated successfully',
  noGoalsSelected: 'No goals selected',
  pleaseSelectGoals: 'Please select at least one goal',
  noImprovementsSelected: 'You have not selected anything to improve.',
  
  // Error messages
  errorLoadingGoals: 'Error loading goals',
  errorSavingGoals: 'Error saving goals',
  tryAgainLater: 'Please try again later',
  
  // Dialog messages
  limitReached: 'Limit',
  limitMessage: 'You can only improve 3 at a time. Remove an existing selection to add a new one.',
  incompleteSelection: 'Incomplete Selection',
  incompleteMessage: 'You must select exactly 3 areas to improve to continue.',
  selectedGoals: 'Your Selected Goals',
  selectedGoalsSubheader: 'You have selected 3 areas to improve:',
  change: 'Change',
  continue: 'Continue',
  
  // Help text
  helpText: 'Select the areas that are most important to you',
  tipText: 'You can change your selection at any time',
  moreInfo: 'More information about goals',
  
  // Progress
  step1: 'Step 1: Select satisfied areas',
  step2: 'Step 2: Set improvement goals',
  step3: 'Step 3: Create action plan',
  
  // Confirmation
  confirmSelection: 'Confirm Selection',
  confirmMessage: 'Are you sure you want to save these goals?',
  yes: 'Yes',
  no: 'No',
  // Plan results page translations
  summary: 'Summary',
  planComplete: 'Your lifestyle plan is now complete!',
  yourGoals: 'Your goals',
  goalsSummary: 'Here is a summary of your goals and how you plan to achieve them:',
  willImprove: 'I will improve',
  goalAchievedByDate: 'The goal should be achieved by {date}.',
  willDoFollowing: 'I will do the following to achieve it:',
  finallyComplete: 'Finally complete! We\'ll see you again when it\'s time to update your Lifestyle Plan. Good luck!',
  completeLifestylePlan: 'Complete this lifestyle plan',
  loadingPlan: 'Loading your plan...',
  
  // Feedback modal translations
  closingQuestions: 'Closing questions',
  just4Questions: 'Just 4 closing questions about what you think of Bwell work.',
  questionsAnswered: '{answered} / {total} questions answered',
  helpUsImprove: 'Help us improve',
  noQuestionsAvailable: 'No questions available right now.',
  answerRegistered: 'Answer registered',
  pleaseAnswerAll: 'Please answer all questions to continue',
  sending: 'Sending...',
  sendAnswers: 'Send answers',
  failedToSend: 'Failed to send answers. Please try again.',
  thankYouForFeedback: 'Thank you for your feedback!',
  feedbackHelpsImprove: 'Your answers help us improve Bwell.',
  failedToLoadQuestions: 'Failed to load feedback questions'
};
